module.exports = __webpack_public_path__ + "img/truebank.525fd609.jpg";